import t from "@/lang/lang";
import { PositionsBaseDataFieldsConfig } from "../position/components/positions-base-data-fields";
import { PositionKind } from "../position/types/position-kind";
import { OptionAvailability } from "../position/types/position-base-data";
import { shsPricesUsed } from "./shs-prices-used";

/**
 * shsPositionsBaseDataFieldsConfig configures the
 * {@link PositionsBaseDataFields} of the SHS positions base data.
 * Options are offered outside of any building or in a room, see
 * `SHSPositions.ValidateBaseData`,
 * backend/core/omni/domain/servicekindrules/shs_positions.go.
 * Sub-positions are text.
 */
export const shsPositionsBaseDataFieldsConfig: PositionsBaseDataFieldsConfig = {
  availabilities: [
    { value: OptionAvailability.ZeroGrouping, label: t("Übergreifend") },
    { value: OptionAvailability.GroupArea, label: t("Gebäude & Raum") },
  ],
  pricesUsed: shsPricesUsed,
  subPositionKinds: [PositionKind.Text],
};
